import { nanoid } from 'nanoid'
import { useContext } from 'react'
import { BuilderContext } from '../store/store.Builder'
// FieldDefinitions.js component
import SpacerField from './components/SpacerField/SpacerField'
import InputField from './components/InputField/InputField'
import NumberField from './components/NumberField/NumberField'
import SelectField from './components/SelectField/SelectField'
import TextAreaField from './components/TextAreaField/TextAreaField'
import TextField from './components/TextField/TextField'
import ButtonField from './components/ButtonField/ButtonField'
import DividerField from './components/DividerField/DividerField'
import CheckboxField from './components/CheckboxField/CheckboxField'
import RadioField from './components/RadioField/RadioField'
import RateField from './components/RateField/RateField'
import SwitchField from './components/SwitchField/SwitchField'
import TimePickerField from './components/TimePickerField/TimePickerField'
import UploadField from './components/UploadField/UploadField'
import DatePickerField from './components/DatePickerField/DatePickerField'
import RangeDatePickerField from './components/RangeDatePickerInput/RangeDatePickerField'
import TitleField from './components/TitleField/TitleField'
import DoubleCustomField from './components/DoubleCustomField/DoubleCustomField'
import EmailField from './components/EmailField/EmailField'
import PostalCodeField from './components/PostalCodeField/PostalCodeField'
import PhoneField from './components/PhoneField/PhoneField'
import RGPDField from './components/RGPDField/RGPDField'
import UrlField from './components/UrlField/UrlField'
import {
  SvgTitleField,
  SvgInputField,
  SvgDividerField,
  SvgHeadlineField,
  SvgSwitchField,
  SvgRateField,
  SvgTimePickerField,
  SvgDatePickerField,
  SvgUploadField,
  SvgRangeDatePickerField,
  SvgNumberField,
  SvgSelectField,
  SvgRadioField,
  SvgCheckboxField,
  SvgTextField,
  SvgPostalCodeForField,
  SvgInputEmailForField,
  SvgPhoneForField,
  SvgShortTextField,
  SvgTitleForField,
  SvgTEXTAREAForField,
  SvgTextForField,
  SvgSelectForField,
  SvgInputForField,
  SvgDividerForField,
  SvgRateForField,
  SvgNumberForField,
  SvgSwitchForField,
  SvgRadioForField,
  SvgDateForField,
  SvgCheckboxForField,
  SvgTimeForField,
  SvgRangeDateForField,
  SvgFileForField,
  SvgDoubleCustomForField,
  SvgInputUrlForField,
  SvgRGPDField,
} from '../../../../components/svg/SvgComponents'

export const design_default = {
  display: 'flex',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  color: '#000000',
  backgroundColor: '#ffffff',
  height: 'auto',
  margin: '0px 0px 0px 0px',
  padding: '10px 10px 10px 10px',
  fontWeight: '400',
  borderRadius: '10',
  borderColor: 'transparent',
  borderWidth: '0',
  borderStyle: 'solid',
  letterSpacing: '0',
  wordWrap: 'break-word',
  justifyContent: 'flex-start',
  boxShadow: '0 20px 27px 0 rgba(0,0,0,.05)',
}

export const design_default_field = {
  display: 'flex',
  fontFamily: 'Arial',
  fontSize: '14px',
  color: '#000000',
  backgroundColor: '#ffffff',
  height: 'auto',
  flex: '1 1 0%',
  margin: '0px 0px 0px 0px',
  padding: '10px 15px 15px 10px',
  fontWeight: '400',
  borderRadius: '0',
  borderColor: 'transparent',
  gap: '0',
  overflow: 'hidden',
  borderWidth: '0',
  borderStyle: 'solid',
  letterSpacing: '0',
  wordWrap: 'break-word',
  justifyContent: 'flex-start',
  boxShadow: '0 20px 27px 0 rgba(0,0,0,.05)',
}

export const design_default_label = {
  display: 'flex',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  color: '#344767',
  backgroundColor: 'transparent',
  height: 'auto',
  padding: '10px 10px 10px 10px',
  flex: '1 1 0%',
  fontWeight: '700',
  borderRadius: '0',
  borderColor: 'transparent',
  borderWidth: '0',
  borderStyle: 'solid',
  letterSpacing: '0',
  wordWrap: 'break-word',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  boxShadow: 'none',
}

export const design_default_description = {
  display: 'flex',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  color: '#67748e',
  backgroundColor: 'transparent',
  height: 'auto',
  padding: '10px 10px 10px 10px',
  flex: '1 1 0%',
  fontWeight: '400',
  borderRadius: '0',
  borderColor: 'transparent',
  borderWidth: '0',
  borderStyle: 'solid',
  letterSpacing: '0',
  wordWrap: 'break-word',
  justifyContent: 'flex-start',
  boxShadow: 'none',
  overflow: 'hidden',
}

export const design_default_input = {
  display: 'flex',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  color: '#495057',
  backgroundColor: 'transparent',
  height: 'auto',
  padding: '20px 20px 20px 10px',
  margin: '5px 5px 5px 5px',
  width: '90%',
  height: '30px',
  fontWeight: '400',
  borderRadius: '10',
  borderColor: '#d2d6da',
  borderWidth: '1',
  borderStyle: 'solid',
  letterSpacing: '0',
  wordWrap: 'break-word',
  justifySelf: 'flex-start',
  boxShadow: 'none',
  overflow: 'hidden',
  maxHeight: 'none',
  alignItems: 'center',
}

export const STYLE_CONSTANTS = {
  DESCRIPTION_TEXT: 'Votre description...',
  OPTION: [
    {
      id: nanoid(),
      value: 'Votre option',
      label: 'Votre option',
      rights: ['ALLeveryoneALL'],
    },
  ],
  DESCRIPTION_VISIBLE: true,
  REQUIRED: false,
  DESIGN: {
    label_design: { ...design_default_label },
    description_design: { ...design_default_description },
    design: { ...design_default_field },
    input_design: { ...design_default_input },
  },
}

const TITLE_FIELD = {
  type: 'title',
  component: TitleField,
  SvgImage: SvgTitleForField,
  SvgBackgroundColor: '#6184C6',
  will_contain_value: false,
  // details: 'Zone de titre de votre formulaire',
  SvgColor: '#fff',
  title: 'Titre',
  label: 'Titre de mon formulaire',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  label_design: { ...design_default_label },
  description_design: { ...design_default_description },
  design: { ...design_default_field },
}

const RGPD_FIELD_VILLE = {
  type: 'rgpdville',
  component: RGPDField,
  SvgImage: SvgRGPDField,
  SvgBackgroundColor: '#6184C6',
  will_contain_value: false,
  SvgColor: '#fff',
  title: 'RGPD Ville',
  label: 'RÈGLEMENT GENERAL SUR LA PROTECTION DES DONNÉES (RGPD) ',
  description:
    "Les informations et justificatifs recueillis font l’objet d’un traitement destiné à la délivrance des prestations demandées. Ils sont protégés et seront conservés pendant la durée légale et celle de leur utilité. Les destinataires en sont les services de la Ville délivrant ces prestations. Conformément au Règlement UE 2016/679 du 27 avril 2016 (RGPD) et à la loi « Informatique et libertés » du 6 janvier 1978 modifiée, vous disposez sous conditions et sauf exceptions d’un droit d’accès, de rectification, d’effacement, de portabilité, d’opposition, de limitation des traitements, de retrait de votre consentement à tout moment, et de réclamation auprès de la CNIL. Pour exercer vos droits, contactez-nous par courrier à la mairie de Montpellier 1 place Georges Frêche 34267 Montpellier Cedex 2, ou par courriel à l'adresse donneespersonnelles.ville@villemontpellier.fr",
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  label_design: { ...design_default_label },
  description_design: { ...design_default_description },
  design: { ...design_default_field },
}

const RGPD_FIELD_METRO = {
  type: 'rgpd3m',
  component: RGPDField,
  SvgImage: SvgRGPDField,
  SvgBackgroundColor: '#6184C6',
  will_contain_value: false,
  SvgColor: '#fff',
  title: 'RGPD 3M',
  label: 'RÈGLEMENT GENERAL SUR LA PROTECTION DES DONNÉES (RGPD) ',
  description:
    "Les informations et justificatifs recueillis font l’objet d’un traitement destiné à la délivrance des prestations demandées. Ils sont protégés et seront conservés pendant la durée légale et celle de leur utilité. Les destinataires en sont les services de la Métropole délivrant ces prestations. Conformément au Règlement UE 2016/679 du 27 avril 2016 (RGPD) et à la loi « Informatique et libertés » du 6 janvier 1978 modifiée, vous disposez sous conditions et sauf exceptions d’un droit d’accès, de rectification, d’effacement, de portabilité, d’opposition, de limitation des traitements, de retrait de votre consentement à tout moment, et de réclamation auprès de la CNIL. Pour exercer vos droits, contactez-nous par courrier à Montpellier Méditerranée Métropole, 50 Place Zeus, CS 39556, 34961 Montpellier Cedex, ou par courriel à l'adresse donneespersonnelles.3m@montpellier.fr",
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  label_design: { ...design_default_label },
  description_design: { ...design_default_description },
  design: { ...design_default_field },
}

const DIVIDER_FIELD = {
  type: 'divider',
  component: DividerField,
  SvgImage: SvgDividerForField,
  will_contain_value: false,
  SvgBackgroundColor: '#18ACBA',
  // details: 'Insérer une ligne séparatrice',
  SvgColor: '#000',
  title: 'Séparateur',
  design: { ...design_default },
}

export const INPUT_FIELD = {
  type: 'input',
  component: InputField,
  SvgImage: SvgInputForField,
  SvgBackgroundColor: '#FCA3B9',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Texte',
  label: 'Titre de mon entrée',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  has_max_length: false,
  max_length: null,
  ...STYLE_CONSTANTS.DESIGN,
}

const NUMBER_FIELD = {
  type: 'number',
  component: NumberField,
  SvgImage: SvgNumberForField,
  SvgBackgroundColor: '#8CA9D3',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Nombre',
  label: 'Titre de mon champ numérique',
  placeholder: '150',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const RATE_FIELD = {
  type: 'rate',
  component: RateField,
  SvgImage: SvgRateForField,
  SvgBackgroundColor: '#FFBB98',
  will_contain_value: true,
  // details: 'Champ de satisfcation',
  SvgColor: '#000',
  title: 'Notation',
  label: 'Titre de mon évaluation',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const SWITCH_FIELD = {
  type: 'switch',
  component: SwitchField,
  SvgImage: SvgSwitchForField,
  SvgBackgroundColor: '#C3CBD6',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Choix',
  label: 'Titre de mon bouton bascule',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const UPLOAD_FIELD = {
  type: 'Upload',
  component: UploadField,
  SvgImage: SvgFileForField,
  SvgBackgroundColor: '#fae6b1',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Fichier',
  label: 'Nom de mon champ de téléchargement',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const TIMEPICKER_FIELD = {
  type: 'timepicker',
  component: TimePickerField,
  SvgImage: SvgTimeForField,
  SvgBackgroundColor: '#BACEC1',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Heure',
  label: "Titre de mon sélecteur d'heure",
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const DATE_FIELD = {
  type: 'Date',
  component: DatePickerField,
  SvgImage: SvgDateForField,
  SvgBackgroundColor: '#B3DEE5',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Date',
  label: 'Nom de mon champ de date',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const RANGEDATE_FIELD = {
  type: 'Range Date',
  component: RangeDatePickerField,
  SvgImage: SvgRangeDateForField,
  title: 'Plage de dates',
  will_contain_value: true,
  SvgBackgroundColor: '#FEBEB0',
  SvgColor: '#000',
  label: "Intitulé de mon libellé d'intervalle de dates",
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const SELECT_FIELD = {
  type: 'select',
  component: SelectField,
  SvgImage: SvgSelectForField,
  SvgBackgroundColor: '#EBC999',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Sélection',
  label: 'Intitulé de ma liste déroulante',
  is_options_field: true,
  is_unique_key: false,
  options: STYLE_CONSTANTS.OPTION,
  options_users: [],
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const RADIO_FIELD = {
  type: 'radio',
  component: RadioField,
  SvgImage: SvgRadioForField,
  SvgBackgroundColor: '#31383F',
  will_contain_value: true,
  SvgColor: '#FFF',
  title: 'Radio',
  label: 'Titre de mon champ de choix unique',
  is_options_field: true,
  is_unique_key: false,
  options: STYLE_CONSTANTS.OPTION,
  options_users: [],
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
  specific_input_design: {
    height: 'auto',
  },
}

const CHECKBOX_FIELD = {
  type: 'checkbox',
  component: CheckboxField,
  SvgImage: SvgCheckboxForField,
  will_contain_value: true,
  title: 'Case à cocher',
  SvgBackgroundColor: '#DD8EA4',
  SvgColor: '#000',
  label: 'Intitulé de ma case à cocher',
  is_options_field: true,
  is_unique_key: false,
  options: STYLE_CONSTANTS.OPTION,
  options_users: [],
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const TEXT_FIELD = {
  type: 'text',
  component: TextField,
  SvgImage: SvgTextForField,
  will_contain_value: false,
  SvgBackgroundColor: '#8CBDB9',
  SvgColor: '#000',
  title: 'Paragraphe',
  label: 'Titre de mon texte',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  ...STYLE_CONSTANTS.DESIGN,
}

const TEXTAREA_FIELD = {
  type: 'textarea',
  component: TextAreaField,
  SvgImage: SvgTEXTAREAForField,
  will_contain_value: true,
  SvgBackgroundColor: '#CCD9E2',
  SvgColor: '#000',
  title: 'Long Texte',
  label: 'Titre de ma zone de saisie',
  placeholder: 'Votre texte indicatif',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  has_max_length: false,
  max_length: null,
  ...STYLE_CONSTANTS.DESIGN,
}

const DOUBLE_CUSTOM_FIELD = {
  type: 'doubleCustom',
  component: DoubleCustomField,
  SvgImage: SvgDoubleCustomForField,
  SvgBackgroundColor: '#52C41A',
  SvgColor: '#fff',
  title: 'Double Custom',
  margin: STYLE_CONSTANTS.MARGIN,
  fields: [
    { ...INPUT_FIELD, id: nanoid(), isASubField: true },
    { ...INPUT_FIELD, id: nanoid(), isASubField: true },
  ],
}

const EMAIL_FIELD = {
  type: 'email',
  component: EmailField,
  SvgImage: SvgInputEmailForField,
  SvgBackgroundColor: '#FCA3B9',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Email',
  label: "Titre de ma zone d'email",
  placeholder: 'eric.dupond@gmail.com',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const POSTALCODE_FIELD = {
  type: 'postalcode',
  component: PostalCodeField,
  SvgImage: SvgPostalCodeForField,
  SvgBackgroundColor: '#8CA9D3',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Code postal',
  label: 'Titre de mon code postal',
  placeholder: '34000',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const PHONE_FIELD = {
  type: 'phone',
  component: PhoneField,
  SvgImage: SvgPhoneForField,
  SvgBackgroundColor: '#8CA9D3',
  will_contain_value: true,
  SvgColor: '#000',
  title: 'Numéro de téléphone',
  label: 'Titre de mon numéro de téléphone',
  placeholder: '04 67 12 61 02',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  required: STYLE_CONSTANTS.REQUIRED,
  is_axis_key: false,
  ...STYLE_CONSTANTS.DESIGN,
}

const URL_FIELD = {
  type: 'url',
  component: UrlField,
  SvgImage: SvgInputUrlForField,
  SvgBackgroundColor: '#6184C6',
  will_contain_value: false,
  SvgColor: '#fff',
  title: 'URL',
  label: 'Titre de mon champ URL',
  url_target: '#',
  description: STYLE_CONSTANTS.DESCRIPTION_TEXT,
  descriptionVisible: STYLE_CONSTANTS.DESCRIPTION_VISIBLE,
  label_design: { ...design_default_label },
  description_design: { ...design_default_description },
  design: { ...design_default_field },
}

// CATEGORIES POUR LA SIDEBARFIELD
export const categoriesFields = {
  common: {
    title: 'Fréquemment utilisés',
    fields: [
      TITLE_FIELD,
      TEXTAREA_FIELD,
      SELECT_FIELD,
      INPUT_FIELD,
      DIVIDER_FIELD,
      UPLOAD_FIELD,
      EMAIL_FIELD,
      URL_FIELD,
      RGPD_FIELD_VILLE,
      RGPD_FIELD_METRO,
    ],
  },
  input: {
    title: 'Entrées de texte',
    fields: [INPUT_FIELD, TEXTAREA_FIELD, EMAIL_FIELD, URL_FIELD],
  },
  number: {
    title: 'Entrées de nombre',
    fields: [NUMBER_FIELD, RATE_FIELD, POSTALCODE_FIELD, PHONE_FIELD],
  },
  select: {
    title: 'Entrées de choix',
    fields: [SWITCH_FIELD, SELECT_FIELD, RADIO_FIELD, CHECKBOX_FIELD],
  },
  date: {
    title: 'Entrées de dates',
    fields: [DATE_FIELD, TIMEPICKER_FIELD, RANGEDATE_FIELD],
  },
  special: {
    title: 'Entrées spéciales',
    fields: [
      DIVIDER_FIELD,
      TITLE_FIELD,
      UPLOAD_FIELD,
      RGPD_FIELD_VILLE,
      RGPD_FIELD_METRO,
    ],
  },
}

export const fields = [
  TITLE_FIELD,
  RGPD_FIELD_VILLE,
  RGPD_FIELD_METRO,
  DIVIDER_FIELD,
  INPUT_FIELD,
  RATE_FIELD,
  SWITCH_FIELD,
  TIMEPICKER_FIELD,
  UPLOAD_FIELD,
  DATE_FIELD,
  RANGEDATE_FIELD,
  NUMBER_FIELD,
  SELECT_FIELD,
  RADIO_FIELD,
  CHECKBOX_FIELD,
  TEXT_FIELD,
  TEXTAREA_FIELD,
  EMAIL_FIELD,
  URL_FIELD,
  POSTALCODE_FIELD,
  PHONE_FIELD,
]

// Ceux-ci définissent comment nous rendons le champ
// Remplacez les renderers existants par ceux-ci
export const renderers = fields.reduce((acc, field) => {
  acc[field.type] = field.component
  return acc
}, {})

renderers['spacer'] = SpacerField
